<template>
  <div class="compare-plan-component">
    <div class="compare-plan">
      <h3>
        {{ $i18nPresenter.t('Compare Plans') }}
      </h3>
    </div>
    <div class="sticky-wrapper " :class="billingCycle" id="sticky-wrapper">
      <div
        class="sticky-plan-bar"
        :class="{
          [billingCycle]: true,
          'is-sticky': isHeaderSticky
        }"
      >
        <div class="container sticky-bar-container">
          <div class="plans-row">
            <div
              class="plans-row__picker"
              :class="{
                [billingCycle]: true,
                'is-visible': isHeaderSticky,
              }"
              id="plans-row-picker"
            >
              <aha-select
                v-if="billingCycle !== 'educational'"
                class="py-3 w-36"
                :value="billingCycle"
                @change="(e) => changePlan(e)"
              >
                <aha-select-option value="annual">
                  {{ $i18nPresenter.t('Yearly plans') }}
                </aha-select-option>
                <aha-select-option value="monthly">
                  {{ $i18nPresenter.t('Monthly plans') }}
                </aha-select-option>
              </aha-select>
            </div>
            <div class="plans-row__items">
              <div
                v-for="(item, index) in getPricings"
                :key="'pricing-' + index"
                class="pricing-item"
                :class="`pricing-item-${index + 1}`"
              >
                <h4>
                  {{ item['label'] }} {{ item['planIcon'] }}
                </h4>

                <span class="pricing-currency">
                  <span class="pricing-currency-lv1" :class="{'custom': item.label === 'Enterprise'}">
                    <span
                      class="pricing-currency-lv2"
                      v-if="showCustom(item['label'])"
                    >{{ symbolCurrency }}</span>{{ setTranslationforPlainText(item['price']) }}
                  </span>
                  <div
                    :class="{'opacity-0': (item['price'] === '0'
                      || item['smaller-price'] === 0 || item['label'] === 'Enterprise') }"
                  >
                    <span class="pricing-currency-lv4">  {{ $i18nPresenter.t('per month') }}
                    </span>
                  </div>
                </span>

                <div
                  class="upgrade-buttons"
                  :class="{
                    'visible': isHeaderSticky,
                    'custom': item.label === 'Enterprise'
                  }"
                >
                  <aha-button
                    v-if="item['label'] !== 'Free'"
                    :disabled="permission[item.permissionKey] || isCreatingCustomerPortal"
                    class="btn-pricing-feature"
                    @click="goToUpgradePage(item)"
                  >
                    <span v-if="item.label !== 'Enterprise'">{{ $i18nPresenter.t('Buy Now') }}</span>
                    <span v-else>{{ $i18nPresenter.t('Speak to Us') }}</span>
                    <aha-spinner variant="white" v-if="isCreatingCustomerPortal" />
                  </aha-button>
                </div>
                <!-- <p class="plan_description" v-if="!isHeaderSticky">
                  {{ $i18nPresenter.t(item['compareDescription']) }}
                </p> -->
                <!-- <p
                  class="plan_description"
                  :class="{'hide-des': isHeaderSticky}"
                  v-html="$i18nPresenter.t(item['compareDescription'])"
                >
                </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div
          class="section-container-line"
        >
          <div>
            <div
              class="item-feature-des items-stretch plan_description"
            >
              <div class="tc__cell--feature-name">
              </div>
              <div
                v-for="(item, index) in getPricings"
                :key="index"
                :class="`text-section-title tc__cell--feature-value item-column-${index + 1}`"
                v-html="$i18nPresenter.t(item['compareDescription'])"
              >
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(featuresInSection, featureSectionName) in features"
          :key="featureSectionName"
          class="section-container-line"
        >
          <div v-if="!byPassSection.includes(featureSectionName)">
            <div class="section-name">
              <div class="tc__header-title">
                {{ $i18nPresenter.t(uppercaseSectionName(featureSectionName)) }}
              </div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
            </div>
            <div
              v-for="(feature, key, fIndex) in featuresInSection"
              :key="key + '-' + fIndex"
              class="item-feature-des items-stretch"
            >
              <div class="tc__cell--feature-name">
                <span>
                  <span>{{ $i18nPresenter.t(feature.title) }}</span>
                  <span class="items-center tooltip" v-tooltip="$i18nPresenter.t(feature.tooltipVal)">
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                  </span>
                </span>
              </div>
              <div
                v-for="(item, kIndex) in feature.planVal"
                :key="key + '-' + item + '-' + kIndex"
                class="text-section-title tc__cell--feature-value"
                :class="`item-column-${kIndex + 1} ${feature.group}`"
              >
                <span v-if="!fIndex && kIndex === 2" class="fake-bg-line"></span>
                <span v-if="typeof(item) === 'boolean' && item" class="text-section-title-lv1">✓</span>
                <span
                  v-else-if="typeof(item) === 'boolean' && !item"
                  class="text-section-title-lv2"
                >✗</span>

                <span
                  v-else-if="key === 'max-participants'"
                  class="font-bold"
                >
                  <aha-icon
                    name="user-solid"
                    width="12"
                    height="12"
                    viewBox="0 0 16 17"
                  />
                  {{ setTranslationforPlainText(item) }}
                </span>
                <span
                  v-else
                >
                  {{ setTranslationforPlainText(item) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SpeakToUsModal
      :isOpenModal="isOpenSpeakToUsModal"
      @hide="closeSpeakToUsModal"
      :email="currentUser.email"
      v-if="isOpenSpeakToUsModal"
      @showThanksModal="showThanksModal"
    />
    <ThanksYourRequestModal
      @closeThanksModal="isThanksRequestModal= false"
      v-if="isThanksRequestModal"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/util'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v3/PaymentLocalizationMixin'
import SpeakToUsModal from '@/components-v2/my-plan/user-pricing-v3/SpeakToUsModal.vue'
import ThanksYourRequestModal from '@/components-v2/my-plan/user-pricing-v3/ThanksYourRequestModal.vue'

export default {
  components: {
    SpeakToUsModal,
    ThanksYourRequestModal,
  },
  mixins: [PaymentLocalizationMixin],
  props: {
    scrollToPricing: {
      type: Function,
      default: () => {},
    },
    tooglePlanDropdown: {
      type: Function,
      default: () => {},
    },
    togglePlan: {
      type: Function,
      default: () => {},
    },
    features: {
      type: Object,
      default: () => {},
    },
    plan: {
      type: Object,
      default: () => {},
    },
    billingCycle: {
      type: String,
      default: 'annual',
    },
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      byPassSection: ['planPrices', 'plansDropdown'],
      dataPlansDropdown: [],
      isHeaderSticky: false,
      isOpenSpeakToUsModal: false,
      isThanksRequestModal: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      promotionCode: (state) => state.promotionCode,
      isCreatingCustomerPortal: (state) => state.isCreatingCustomerPortal,
    }),

    getPlansDropdown() {
      let plans = this.features.plansDropdown
      if (plans) {
        plans = plans.filter((item) => {
          return item.plan !== 'educational'
        })
      }
      return plans
    },
    getPricings() {
      return this.plan.planPrices
    },
    getFeaturePlans() {
      return this.features
    },
  },

  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.dataPlansDropdown = this.getPlansDropdown
  },
  methods: {
    ...mapActions(['createCheckoutSessionForPersonPlan', 'createCustomerPortalUpgradeFlowAction']),
    closeModalThanksRequest() {
      this.isThanksRequestModal = false
    },
    showThanksModal() {
      this.isThanksRequestModal = true
    },
    closeSpeakToUsModal() {
      this.isOpenSpeakToUsModal = false
    },
    openSpeakToUsModal() {
      this.isSpeakToUsModalOpen = true
    },
    handleSpeakToUsModalHide() {
      this.isSpeakToUsModalOpen = false
      this.isThanksYourRequestModalOpen = true
    },
    goToUpgradePage(price) {
      if (price.label === 'Enterprise') {
        this.isOpenSpeakToUsModal = true
        return
      }
      const { upgradeLink: url } = price
      const plan = /content=([^&]+)/.exec(url)[1] || ''
      const planType = `${plan}`
      Utils.mixpanelTracking('My plan > Upgrade > Bottom', 'Upgrade', planType)
      if (this.isUserApplyNewPayment) {
        const payload = {
          plan: price.planKey,
        }
        if (this.promotionCode) {
          payload.promotionCode = this.promotionCode.code
        }
        if (this.currentUser.plan !== 'free') {
          this.createCustomerPortalUpgradeFlowAction(payload)
        } else {
          this.createCheckoutSessionForPersonPlan(payload)
        }
        return
      }
      this.$router.push(url)
    },
    getPlansTitle(billingCycle) {
      if (billingCycle === 'annual') {
        return this.$i18nPresenter.t('Yearly plans')
      }
      if (billingCycle === 'monthly') {
        return this.$i18nPresenter.t('Monthly plans')
      }
      if (billingCycle === 'educational') {
        return this.$i18nPresenter.t('Educational plans')
      }
      return null
    },
    uppercaseSectionName(name) {
      return `${name[0].toUpperCase()}${name.slice(1)}`
    },
    changePlan(plan) {
      this.togglePlan(plan)
    },

    handleScroll() {
      const stickyBar = document.getElementsByClassName('sticky-plan-bar')[0]
      const stop = stickyBar.getBoundingClientRect().top + window.scrollY - 120
      const docBody = document.documentElement || document.body.parentNode || document.body
      const hasOffset = window.pageYOffset !== undefined
      let scrollTop
      // eslint-disable-next-line prefer-const
      scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop

      if (scrollTop >= stop) {
        this.isHeaderSticky = true
      } else if (scrollTop <= stop - 50) {
        this.isHeaderSticky = false
      }
    },
    showCustom(label) {
      return label !== 'Enterprise'
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
